/**
 * ActivityFigure — how much a place saw in the last day, and when: the total beside a bar for
 * each stretch of the time the count covers.
 */

import type { ReactElement } from 'react';
import React from 'react';

import { fmtDurationTwoUnits } from '@/lib/time';
import type { ActivityInfo, LauncherTileSize } from '@/types/panels';

import { ActivityBars } from './ActivityBars';
import { TileFigure } from './TileFigure';

interface Props {
    info: ActivityInfo;
    size: LauncherTileSize;
}

export const ActivityFigure = ({ info, size }: Props): ReactElement => {
    // A capped count is a floor, so it reads as `500+`.
    const value = `${info.count}${info.isCapped ? '+' : ''}`;
    return (
        <TileFigure
            size={size}
            value={value}
            unit="in the last day"
            graphic={(
                <ActivityBars
                    bins={info.bins}
                    size={size}
                />
            )}
            legend={(
                <span className="flex justify-between text-xs text-occ-foreground-tertiary">
                    <span>
                        {fmtDurationTwoUnits(info.spanMs)}
                        {' '}
                        ago
                    </span>
                    <span>now</span>
                </span>
            )}
            brief={value}
        />
    );
};
